import React from 'react';
import { Container, Paper, Typography, Button, Box } from '@mui/material';
import GoogleIcon from '@mui/icons-material/Google';

const Login: React.FC = () => {
  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Paper elevation={3} sx={{ p: 4, textAlign: 'center', width: '100%' }}>
          <Typography
            variant="h4"
            component="h1"
            gutterBottom
            sx={{
              color: import.meta.env.DEV ? '#c62828' : 'inherit'
            }}
          >
            {import.meta.env.VITE_APP_NAME}
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
            Zaloguj się, aby kontynuować
          </Typography>
          <Button
            variant="contained"
            size="large"
            href="/.auth/login/google"
            startIcon={<GoogleIcon />}
            sx={{ mt: 2 }}
          >
            Zaloguj przez Google
          </Button>
        </Paper>
      </Box>
    </Container>
  );
};

export default Login;